import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  ActivatedRoute,
  Router,
  RouterModule,
  NavigationEnd,
  Event,
  RouterLink,
} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { RequestMapper } from '../../../request-mapper';
import { CommonModule } from '@angular/common';
import { AppConfigService } from '../../../services/config/app-config.service';
import { CommonUtilService } from '../../../services/common-util/common-util.service';
import { filter } from 'rxjs/operators';
import { WishlistDialogComponent } from '../wishlist-dialog/wishlist-dialog.component';
import { ThemeToggleService } from '../../../services/theme-Toggle/theme-toggle.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { AuthService } from '../../../services/auth/auth-service';
import { FindDetailWishListService } from '../../../services/common/find-detail-wishlist.shared';
import { ToastrService } from 'ngx-toastr';
import { ReviewDataService } from '../../../services/raintree/Transmission/review-data.service';

@Component({
  standalone: true,
  selector: 'app-dp-side-nav',
  templateUrl: './dp-side-nav.component.html',
  styleUrls: ['./dp-side-nav.component.scss'],
  imports: [
    RouterModule,
    CommonModule,
    RouterLink,
    MatTooltipModule,
    ClipboardModule,
  ],
})
export class DpSideNavComponent implements OnInit, AfterViewInit {
  public themeStyles: any;
  pincodes: any = [];
  public innerWidth: any;
  public selectedNavItem: string = '';
  public fullName: any;
  public role: any;
  public dashboard!: string;
  public pageTitle: string = '';
  public showNavbar: boolean = false;
  public isMobileDevice = false;
  public isLoading = false;
  public navBar: any = [];
  public themeName: string = 'Dark';
  public themeMode: string = 'dark-gold';
  currentRoute: string = '';
  public colorCodes: any[] = [
    { name: 'Dark', value: 'dark-gold', icon: 'moon-line' },
    { name: 'Light', value: 'light-gold', icon: 'theme-light' },
    // { name: 'Dark Legacy', value: 'dark-legacy' },
    // { name: 'Light Legacy', value: 'light-legacy' },
  ];
  public showColorCodes: boolean = false;
  public selectedNavItemIndex: number = -1;
  @ViewChild('scrollMe') private myScrollContainer!: ElementRef;
  icon: string = 'moon-line';
  roleNames = ['RITWIK WORKER', 'PRATI RITWIK WORKER', 'SPR WORKER', 'JK WORKER', 'ADJ WORKER', 'SUPER ADMIN', 'UK WORKER', 'MANDIR WORKER', 'KENDRA WORKER'];
  constructor(
    private _router: Router,
    private dialog: MatDialog,
    private _appConfig: AppConfigService,
    private router: Router,
    private isMobile: CommonUtilService,
    private authService: AuthService,
    private themeToggleService: ThemeToggleService,
    private findDetailWishListService: FindDetailWishListService,
    private toaster: ToastrService,
    // public reviewService: ReviewDataService,
    private _activatedRoute: ActivatedRoute
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects;
      }
    });
  }
  permission: any = {};
  can_mark_reach: boolean = false;
  ngOnInit() {
    this.role = localStorage.getItem('role');
    if (!this.roleNames.includes(this.role)) this.role = 'DP USER';
    // this.permission = this._appConfig.fetchPermissionsByViewName();
    this.permission = this._appConfig.fetchPermissionv3ByViewName();
    const permList = this.fetchPermName(this.permission)

    this.can_mark_reach =
      permList.indexOf('can_mark_reach') !== -1 ? true : false;
    this.isMobileDevice = this.isMobile.isMobileDevice();

    // Apply Theme
    this.themeName = localStorage.getItem('themeName') || 'Dark';
    this.themeMode = localStorage.getItem('themeMode') || 'dark-gold';
    this.icon = localStorage.getItem('icon') || 'moon-line';
    // this.icon = this.colorCodes.filter((item:any) => this.themeName == item.name)[0].icon
    this.toggleColorSchema(this.themeMode, this.themeName, this.icon);

    // url params only
    let routerArray = this.router.url.split('?')[0].split('/');
    routerArray = routerArray.splice(1, routerArray.length);

    // update page label
    let pageView = this.navBar.find(
      (elm: any) => elm.webRoute === routerArray[0]
    );

    if (pageView?.subNav.length) {
      pageView = pageView.subNav.find(
        (elm: any) => elm.webRoute === routerArray[1]
      );
    }
    this.pageTitle = pageView?.label || '';

    this.fullName = localStorage.getItem('fullName');

    this._router.events
      .pipe(filter((event: Event) => event instanceof NavigationEnd))
      .subscribe((event: Event) => {
        if (event instanceof NavigationEnd) {
          this.updateSelectedNavItemFromUrl(event.urlAfterRedirects);
        }
      });
    this.updateSelectedNavItemFromUrl(this._router.url);
  }
  fetchPermName(perm: any, finalPermList: any = []) {
    Object.values(perm).forEach((item: any) =>
      Array.isArray(item) ? finalPermList.push(...item) : typeof item === 'object' && this.fetchPermName(item, finalPermList)
    );
    return [...new Set(finalPermList)];
  }
  fetchDistrictPincode(type: string, state: any, district: any) {

    this.dialog.open(WishlistDialogComponent, {
      data: { type, state: state, district: district },
    });


  }

  openWishlistDialog(type: string) {
    // this.fetchDistrictPincode()
    const { state, district } = this.findDetailWishListService.getVariables();
    if (state !== undefined && district !== undefined) {
      if (type === 'centralizedPm')
        this.fetchDistrictPincode(type, state, district)
      else {
        this.dialog.open(WishlistDialogComponent, {
          data: { type, selectedState: state, selectedDistrict: district },
        });
      }
      // this.fetchDistrictPincode()
    } else this.toaster.error('Select state and district first');
  }

  updateSelectedNavItemFromUrl(url: string) {
    const foundItem = this.navBar.find((item: { webRoute: string }) =>
      url.includes(`/${item.webRoute}`)
    );
    if (foundItem) {
      this.selectedNavItem = foundItem.label;
    }
  }

  public onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  ngAfterViewInit(): void { }

  showColorCode() {
    setTimeout(() => {
      this.myScrollContainer.nativeElement.scrollTop =
        this.myScrollContainer.nativeElement.scrollHeight;
    }, 300);

    this.showColorCodes = !this.showColorCodes;
  }

  toggleColorSchema(mode: any, name: string, icon: string) {
    this.themeToggleService.applyTheme(mode);
    this.themeName = name;
    this.icon = icon;
    console.log(mode, name, icon);
    localStorage.setItem('themeMode', mode);
    localStorage.setItem('themeName', name);
    localStorage.setItem('icon', icon);

    // Navigation w/ theme selected theme styles
    let htmlCollection = document.getElementsByClassName(
      `${localStorage.getItem('themeMode')}`
    );
    this.themeStyles = getComputedStyle(htmlCollection.item(0)!);
    this.navBar = this._appConfig.getSideNavigation(this.themeStyles);

    this.navBar.forEach((navItem: { subNav: any[] }) => {
      if (navItem.subNav) {
        navItem.subNav = navItem.subNav.filter(
          (value, index, self) =>
            index === self.findIndex((item) => item.label === value.label)
        );
      }
    });
  }
  // get getRoleIconPath() {
  //   return ``
  // }
  get logoutIconPath() {
    return `../../../../assets/images/${localStorage.getItem(
      'themeMode'
    )}/logout-box-r-line.svg`;
  }
  get getThemeIconPath(): string {
    return `../../../../assets/images/${localStorage.getItem(
      'themeMode'
    )}/${localStorage.getItem('icon')}.svg`;
  }
  get userIconPath() {
    return `../../../../assets/images/${localStorage.getItem(
      'themeMode'
    )}/user-line.svg`;
  }
  getThemeModeIconPath(icon: string) {
    return `../../../../assets/images/${localStorage.getItem(
      'themeMode'
    )}/${icon}.svg`;
  }
  selectNavItem(item: any, i: number) {
    if (i == this.selectedNavItemIndex) {
      this.selectedNavItemIndex = -1;
    } else {
      this.selectedNavItemIndex = i;
    }

    this.pageTitle = item.label;
    this.selectedNavItem = item.label;

    if (!item.subNav.length) {
      this._router.navigate([item.webRoute]);
      if (this.showNavbar) {
        this.showNavbar = false;
      }
    }
  }

  clickSubNavItem(event: any, subItemLabel: string) {
    event.stopPropagation();
    // update page title label
    this.pageTitle = subItemLabel;
    if (this.showNavbar) {
      this.showNavbar = false;
    }
  }

  // toggleSidebar() {
  //   const sidebar = document.getElementById('sidebar');
  //   if (sidebar) {
  //     sidebar.classList.toggle('active');
  //   }
  // }

  public logOut() {
    this.authService.logOut();
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
